import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import { Flex, Spinner, Text, useToast } from '@chakra-ui/react';
import { activateTask } from '@/services/taskActivation';
import { changeTaskStatus } from '@/screens/registrations/Tasks/services/changeTaskStatus';
import { TaskChecklistScreen as TaskChecklist } from './TaskChecklist';


export const TaskActivationPage: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>();
  const [isActivating, setIsActivating] = useState(true);
  const [error, setError] = useState<{ message: string; color?: string } | null>(null);
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    const startActivation = async () => {
      console.log('Iniciando ativação da tarefa:', taskId);
      try {
        setIsActivating(true);
        if (taskId) {
          const response = await activateTask(taskId);
          if (response.status === 'done' && response.event_id) {
            history.replace(`/external/event/${response.event_id}`);
            return;
          }
        }
        setIsActivating(false);
      } catch (e: any) {
        console.error('Erro na ativação da tarefa:', e);
        try {
          const parsedError = JSON.parse(e.message);
          setError({
            message: parsedError.message || 'Ocorreu um erro ao ativar a tarefa.',
            color: parsedError.color,
          });
          toast({
            title: 'Erro de Ativação',
            description: parsedError.message || 'Não foi possível ativar a tarefa.',
            status: parsedError.color === 'green' ? 'success' : 'error',
            duration: 7000,
            isClosable: true,
          });
        } catch (parseError) {
          setError({ message: e.message || 'Ocorreu um erro ao ativar a tarefa.' });
          toast({
            title: 'Erro de Ativação',
            description: e.message || 'Não foi possível ativar a tarefa.',
            status: 'error',
            duration: 7000,
            isClosable: true,
          });
        }
        setIsActivating(false);
      }
    };

    if (taskId) {
      startActivation();
    }
  }, [taskId, toast]);

  if (isActivating) {
    return (
      <Flex h="80vh" w="full" align="center" justify="center" direction="column">
        <Spinner size="xl" color="green.500" thickness="4px" />
        <Text mt={4} fontSize="lg" fontWeight="medium">
          Iniciando checklist...
        </Text>
      </Flex>
    );
  }

  if (error) {
    const displayColor = error.color === 'green' ? 'green.500' : 'red.500';
    return (
      <Flex h="80vh" w="full" align="center" justify="center" p={4}>
        <Text color={displayColor} fontSize="xl" fontWeight="bold" textAlign="center">
          {error.message}
        </Text>
      </Flex>
    );
  }

  if (!taskId) return null;

  return (
    <TaskChecklist
      taskId={taskId}
      onClose={() => {
        history.push('/app/tasks');
      }}
      onSubmit={async () => {
        try {
          await changeTaskStatus({ id: taskId }, 'done');
          toast({
            title: 'Sucesso',
            description: 'Checklist finalizado e tarefa concluída com sucesso.',
            status: 'success',
          });
          history.push('/app/tasks');
        } catch (e) {
          console.error('Erro ao finalizar tarefa:', e);
          toast({
            title: 'Erro ao Finalizar',
            description: 'O checklist foi salvo, mas não conseguimos marcar a tarefa como concluída.',
            status: 'warning',
            duration: 7000,
            isClosable: true,
          });
          history.push('/app/tasks');
        }
      }}
    />
  );
};

export default TaskActivationPage;
